import { Text } from '@ps-design-system/components/Text';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export const GeneralRules = ({ generalRules }) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '12px'
      }}
    >
      <Text element="p" typeface="body-2-m" style={{ margin: '0' }}>
        <FormattedMessage
          id="host_rules.general_rules"
          defaultMessage="General rules"
        />
      </Text>
      <Text element="p" style={{ margin: '0', color: '#6A6E7A' }}>
        {generalRules}
      </Text>
    </div>
  );
};

GeneralRules.displayName = 'GeneralRules';
GeneralRules.propTypes = {
  generalRules: PropTypes.string
};
